import { render, staticRenderFns } from "./HomeUser.vue?vue&type=template&id=065e651d&scoped=true&"
import script from "./HomeUser.vue?vue&type=script&lang=js&"
export * from "./HomeUser.vue?vue&type=script&lang=js&"
import style0 from "./HomeUser.vue?vue&type=style&index=0&id=065e651d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065e651d",
  null
  
)

export default component.exports